module.exports = __webpack_public_path__ + "static/media/forkio.e37e8a35.jpg";